import React from 'react';
import Avatar from '../Avatar';

/**
 * Overlapping avatar row with +N overflow, matching dense list mockups.
 */
const AvatarStack = ({ members = [], max = 3, size = 'xs' }) => {
  const list = Array.isArray(members) ? members.filter(Boolean) : [];
  if (list.length === 0) {
    return <span className="text-xs text-secondary-400">—</span>;
  }

  const visible = list.slice(0, max);
  const overflow = list.length - visible.length;

  return (
    <div className="flex items-center">
      <div className="flex -space-x-1.5">
        {visible.map((member) => {
          const name = member.full_name || member.username || member.email || '?';
          const initials = name
            .split(/\s+/)
            .map((p) => p[0])
            .join('')
            .slice(0, 2)
            .toUpperCase();
          return (
            <div
              key={member.id || name}
              className="ring-2 ring-white dark:ring-secondary-800 rounded-full"
              title={name}
            >
              <Avatar
                blobName={member.avatar_blob_name || member.avatar || null}
                alt={name}
                size={size}
                fallbackText={initials}
                className="!ring-0"
                previewable
              />
            </div>
          );
        })}
        {overflow > 0 && (
          <div
            className="h-6 w-6 rounded-full bg-secondary-100 dark:bg-secondary-700 text-secondary-600 dark:text-secondary-300 text-[10px] font-semibold flex items-center justify-center ring-2 ring-white dark:ring-secondary-800"
            title={`${overflow} more`}
          >
            +{overflow}
          </div>
        )}
      </div>
    </div>
  );
};

export default AvatarStack;
